import React, { Component } from 'react'
import { Button, Input, Select, Row, Col, Typography, Form, Card, Table, Tooltip, Modal, Radio, Popconfirm, notification, Badge } from 'antd'
import { FilterOutlined, SaveOutlined } from '@ant-design/icons'
import addIcon from '../../../assets/images/add.svg'
import editIcon from '../../../assets/images/edit.svg'
import deleteIcon from '../../../assets/images/delete.svg'
import Update from '../../../assets/images/input-tick.svg'
// import filterIcon from '../../../assets/images/filter.svg'
import cssconstants from '../../../constants/cssconstants'
import constants, { errormsg, systemParameterTabs as titles }  from '../../../constants/constants'
import './tabs.css'
import Http from '../../../utils/http'
import { cloneDeep } from 'lodash'
import Cookies from 'universal-cookie'
import { cacheRetrieve } from '../../../utils/common'
import { pageHandler, getCookie, COOKIE } from '../../../utils/cookie'

const { Title } = Typography
const { Option } = Select
const { Search } = Input
let cookies = new Cookies()
const station = cookies.get('station')

class BuildUpAreaMapping extends Component {
  constructor(props) {
    super(props)
    this.state = {
      station: getCookie(COOKIE.STATION),
      loading: false,
      workAreasList: [],
      areaList: [],
      workAreasProductsList: [],
      workAreasLocationsList: [],
      search: '',
      exceptionRow: null,
      only_booked: false,
      red_locations: '',
      amber_locations: '',
      system_details: [],

      selworkArea: null,
      filterWorkArea: null,
      area_id: null,

      area_name: '',
      id_wa: null,
      isWAEdit: false,
      waEditRecord: null,
      editArea_name: null,

      p_code: '',
      transfer_type: 'Local',
      dom_intl: 'DOM',
      id_wap: null,
      isWAPEdit: false,
      prodWorkArea: '',
      wapEditRecord :null,
      editProdWorkArea: null,
      editP_code: null,
      editTransfer_type: '',
      editDom_intl: '',
      editprodArea_id: null,

      locations: '',
      id_wal: null,
      isWALEdit: false,
      locWorkArea: '',
      walEditRecord :null,
      editLocations: null,
      editLocWorkArea: null,
      editlocArea_id: null,
      editlocArea_name: null,
      editlocArea_location_group: null,

      duplicate: null,
      pduplicate: null,
      lduplicate: null,
      eduplicate: null,

      selectedArea: '',
      isEdit: false,

      showExceptionsModal: false,
      exceptionList: [],
      exceptionName: null,
      exceptionValue: null,
      exceptionType: 'Local',
      exceptionDomIntl: 'DOM',
      exceptionWorkArea: null,
      exceptionProductID: null,

      editExceptionRecord: null,
      editExceptionName: null,
      editExceptionValue: null,
      editExceptionType: null,
      editExceptionDomIntl: null,
      editExceptionWorkArea: null,
    }
  }

  componentDidMount() {
    let urlarr = window.location.pathname.split('/')
    pageHandler('/'+urlarr[1], getCookie(COOKIE.ROLE))
    const events = new EventSource(process.env.REACT_APP_API_URL+`events?pgtype=sp&stn=${this.state.station}`)
    events.onmessage = (event) => {
      const parsedData = JSON.parse(event.data)
      /* check type of data and call necessary APIs */
      if(!this.state.isListening) this.setState({ isListening: true })
      else {
        if(parsedData.TYPE === 'BUILD_UP_WORK_AREA'){
          this.fetchWorkAreas()
        }
        if(parsedData.TYPE === 'BUILD_UP_WORK_AREA_PRODUCTS'){
          this.fetchWorkAreaProducts()
        }
        if(parsedData.TYPE === 'BUILD_UP_WORK_AREA_LOCATION'){
          this.fetchWorkAreaLocations()
        }
        // if(parsedData.TYPE === 'BUILD_UP_WORK_AREA_EXCEPTIONS'){
        //   this.fetchExceptionList()
        // }
      }
    }
    this.fetchWorkAreas()
    this.fetchWorkAreaProducts()
    this.fetchWorkAreaLocations()
    this.fetchAmberValue()

    // this.fetchExceptionList()
  }
  //FETCH HANDLING DATA
  fetchAmberValue = async () => {
    let callback = this.fetchAmberValueFn
    let pageURL =  `station_details?station=${this.state.station}`
    const headers = {}
    cacheRetrieve(callback, pageURL, headers )
  }
  fetchAmberValueFn = async(response) => {
    const dataResp = await response.json()
    if(dataResp?.data?.length>0) {
      this.setState({
        system_details: dataResp.data,
        only_booked: dataResp.data[0]?.details?.onlybooked, //boolean
        red_locations: dataResp.data[0]?.details?.red_locations || '', //comma seperated string
        amber_locations: dataResp.data[0]?.details?.amber_locations || '', //comma seperated string
      })
    }
  }
  fetchWorkAreas = async () => {
    let callback = this.fetchWorkAreasFn
    let pageURL =  'work_areas'
    let headers = {
      station: this.state.station,
      module: 'buildup'
    }
    cacheRetrieve(callback, pageURL, headers )
  }
  fetchWorkAreasFn = async(resp, event) => {
    if(!event) this.setState({ loading: true })
    const respData = await resp.json()
    if(respData && respData?.data?.length>0){
      let areaList = []
      respData?.data?.map(d => {
        d.id = d?.ids?.[0]
        areaList.push({
          label: d.area_name,
          value: d.id,
        })
      })
      areaList = areaList.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.value === thing.value
        ))
      )
      this.setState({
        workAreasList : respData.data,
        areaList: areaList,
      },()=>{
        let found = false
        if(this.state.selworkArea){
          found = this.state.workAreasList.some(obj=> obj.id === this.state.selworkArea.id)
          if(!found){
            this.setState({ selworkArea: null },()=>{
              this.clearForm('work_areas')
              this.fetchWorkAreaProducts()
            })
          }
          else {
            this.clearForm('work_areas')
          }
        } else {
          this.clearForm('work_areas')
        }
      })
    } else {
      this.setState({
        workAreasList : [],
        areaList: [],
        selworkArea: null
      },()=>{
        this.clearForm('work_areas')
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: 'Work Areas '+respData.message,
        })})
    }

  }

  fetchWorkAreaProducts = async () => {
    let callback = this.fetchWorkAreaProductsFn
    let url = 'work_area_products'
    if(this.state.selworkArea?.id)
      url= url+'?area_id='+this.state.selworkArea.id

    let headers = {
      station: this.state.station,
      module: 'buildup'
    }
    cacheRetrieve(callback, url, headers )
  }

  fetchWorkAreaProductsFn = async(resp) => {
    const respData = await resp.json()
    if(respData && respData.data.length>0){
      this.setState({ workAreasProductsList : respData.data })
    } else {
      this.setState({ workAreasProductsList : [] })
    }
  }

  fetchWorkAreaLocations = async () => {
    let callback = this.fetchWorkAreaLocationsFn
    let url = 'work_arealocations'
    // if(this.state.filterWorkArea)
    //   url= url+'?area_id='+this.state.filterWorkArea
    if(this.state.selworkArea?.id)
      url= url+'?area_name='+this.state.selworkArea.area_name

    let headers = {
      search: this.state.search,
      station: this.state.station,
      module: 'buildup'
    }
    cacheRetrieve(callback, url, headers )
  }

  fetchWorkAreaLocationsFn = async(resp) => {
    const respData = await resp.json()
    if(respData && respData.data && respData.data.length>0){
      respData?.data?.map(d => { d.id = d?.ids?.[0] })
      this.setState({ workAreasLocationsList : respData.data })
    } else {
      if(this.state.search){
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: respData.message,
        })
      }
      this.setState({ workAreasLocationsList : [] })
    }
  }

  changeFilter = (e, type) => {
    if(type === 'location_area'){
      this.setState({ filterWorkArea: e || [], },()=>this.fetchWorkAreaLocations())
    }
  }
  editHandler = (record, type) =>{
    if(type === 'work_areas'){
      this.setState({
        isWAEdit: true,
        area_name: record.area_name,
        id_wa: record.id
      })
    }
    else if(type === 'work_area_products'){
      this.setState({
        isWAPEdit: true,
        p_code: record.details.p_code,
        transfer_type: record.details.transfer_type,
        dom_intl: record.details.dom_intl,
        id_wap: record.id,
        prodWorkArea: record.station+' / '+record.work_area.area_name,
        area_id: record.area_id
      })
    }
    else if(type === 'work_area_locations'){
      this.setState({
        isWALEdit: true,
        locations: record.details.location,
        id_wal: record.id,
        locWorkArea: record.station+' / '+record.work_area.area_name,
        area_id: record.area_id
      })
    }
  }

  addWorkAreas = () => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_workarea',
    }
    //eslint-disable-next-line
    let formdata= {
      station: this.state.station,
      area_name: this.state.area_name,
      module: 'buildup'
    }
    Http.post('/work_area', formdata, { headers })
      .then((data) => {
        if(data && data.status === 200){
          this.setState({
            area_name: '',
            duplicate: null,
          },()=>{
            this.fetchWorkAreas()
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data.data.message,
            })
          })
        } else {
          this.setState({ duplicate:data?.data?.data },()=>setTimeout(() => {this.setState({ duplicate: null })}, 4500))
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data.data.message,
          })
        }
      })
  }
  updateWorkAreas = () => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_workarea'
    }
    let formdata= {
      area_name: this.state.editArea_name,
      station: this.state.station,
      module: 'buildup'
    }
    Http.put('/work_area/'+this.state.waEditRecord.id, formdata, { headers })
      .then((data) => {
        if(data && data.status === 200){
          this.clearTableForm()
          this.fetchWorkAreas()
          this.fetchWorkAreaLocations()
          this.fetchWorkAreaProducts()
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data.data.message,
          })
        } else {
          var tempData = data && data.data && data.data.data ? data.data.data : null
          this.setState({ duplicate: tempData },()=>setTimeout(() => {this.setState({ duplicate: null })}, 4500))
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data.data.message,
          })
        }
      })
  }

  addWorkAreaProducts  = () => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_workareaproducts'
    }
    if(!this.state.selworkArea || !this.state.selworkArea.id){
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: errormsg.sel_work_area,
      })
    }
    if(this.state.selworkArea && this.state.selworkArea.id){
      let formdata= {
        area_id: this.state.selworkArea.id,
        station: this.state.station,
        p_code: this.state.p_code,
        transfer_type: this.state.transfer_type,
        dom_intl: this.state.dom_intl,
        module: 'buildup'
      }
      Http.post('/work_area_product', formdata, { headers })
        .then((data) => {
          if(data && data.status === 200){
            this.setState({
              area_name: '',
              pduplicate: null,
            },()=>{
              this.clearForm('work_area_products')
              if(this.state.selworkArea && this.state.selworkArea.area_name)
                this.setState({ prodWorkArea: station+' / '+this.state.selworkArea.area_name })
              this.fetchWorkAreaProducts()
              notification.destroy()
              notification.success({
                message: 'Success',
                description: data.data.message,
              })
            })
          } else {
            this.setState({ pduplicate:data?.data?.data },()=>setTimeout(() => {this.setState({ pduplicate: null })}, 4500))
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    }
  }

  updateWorkAreaProducts = () => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_workareaproducts'
    }
    let formdata= {
      p_code: this.state.editP_code,
      transfer_type: this.state.editTransfer_type,
      dom_intl: this.state.editDom_intl,
      station: this.state.station,
      area_id: this.state.editprodArea_id,
      module: 'buildup'
    }
    Http.put('/work_area_product/'+this.state.wapEditRecord.id, formdata, { headers })
      .then((data) => {
        if(data && data.status === 200){
          this.setState({
            p_code: '',
            transfer_type: 'Local',
            dom_intl: 'DOM',
            id_wap: null,
            isWAPEdit: false,
            prodWorkArea: '',
            pduplicate: null,
          },()=>{
            if(this.state.selworkArea && this.state.selworkArea.area_name)
              this.setState({ prodWorkArea: station+' / '+this.state.selworkArea.area_name })
            this.clearTableForm()
            this.fetchWorkAreaProducts()
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data.data.message,
            })
          })
        } else {
          this.setState({ pduplicate:data?.data?.data },()=>setTimeout(() => {this.setState({ pduplicate: null })}, 4500))
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data.data.message,
          })
        }
      })
  }

  addWorkAreaLocations  = () => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_workarealocations'
    }
    if(!this.state.selworkArea || !this.state.selworkArea.id){
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: errormsg.sel_work_area,
      })
    }
    if(this.state.selworkArea && this.state.selworkArea.id){
      let formdata= {
        area_name: this.state.selworkArea.area_name,
        station: this.state.station,
        location: this.state.locations,
        module: 'buildup'
      }
      Http.post('/work_arealocation', formdata, { headers })
        .then((data) => {
          if(data && data.status === 200){
            this.setState({
              location: '',
              lduplicate: null,
            },()=>{
              this.clearForm('work_area_locations')
              if(this.state?.selworkArea?.area_name)
                this.setState({ locWorkArea: station+' / '+this.state.selworkArea.area_name })
              this.fetchWorkAreaLocations()
              notification.destroy()
              notification.success({
                message: 'Success',
                description: data.data.message,
              })
            })
          } else {
            this.setState({ lduplicate:data?.data?.data ? data.data.data[0] : null },()=>setTimeout(() => {this.setState({ lduplicate: null })}, 4500))
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    }
  }

  updateWorkAreaLocations = () => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_workarealocations'
    }
    let formdata= {
      location: this.state.editLocations,
      station: this.state.station,
      area_name: this.state.editlocArea_name,
      location_group: this.state.editlocArea_location_group,
      module: 'buildup'
    }
    Http.put('/work_arealocation', formdata, { headers })
      .then((data) => {
        if(data && data.status === 200){
          this.setState({
            locations: '',
            id_wal: null,
            isWALEdit: false,
            locWorkArea: '',
            lduplicate: null,
          },()=>{
            if(this.state?.selworkArea?.area_name)
              this.setState({ locWorkArea: station+' / '+this.state.selworkArea.area_name })
            this.clearTableForm()
            this.fetchWorkAreaLocations()
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data.data.message,
            })
          })
        } else {
          this.setState({ lduplicate:data?.data?.data ? data.data.data[0] : null },()=>setTimeout(() => {this.setState({ lduplicate: null })}, 4500))
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data.data.message,
          })
        }
      })
  }
  deleteHandler = (record, type) => {
    let title = type === 'work_areas' ? '_workarea' : type === 'work_area_products' ? '_workareaproducts' : type === 'work_area_locations' ? '_workarealocations' : ''
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + title
    }
    if(type === 'work_areas'){
      let formdata= {
        is_delete: true,
        station: this.state.station,
        area_name: record.area_name,
        module: 'buildup'
      }
      Http.put('/work_area/'+record.id, formdata, { headers })
        .then((data) => {
          if(data && data.status === 200){
            this.setState({
              area_name: '',
              id_wa: null,
              isWAEdit: false,
            },()=>{
              // this.clearForm('work_areas')
              this.fetchWorkAreas()
              notification.destroy()
              notification.success({
                message: 'Success',
                description: data.data.message,
              })
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    } else if (type === 'work_area_products') {
      let formdata= {
        is_delete: true,
        module: 'buildup'
      }
      Http.put('/work_area_product/'+record.id, formdata, { headers })
        .then((data) => {
          if(data && data.status === 200){
            this.setState({
              p_code: '',
              transfer_type: 'Local',
              dom_intl: 'DOM',
              id_wap: null,
              isWAPEdit: false,
              prodWorkArea: ''
            },()=>{
              this.clearForm('work_area_products')
              this.fetchWorkAreaProducts()
              notification.destroy()
              notification.success({
                message: 'Success',
                description: data.data.message,
              })
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })

    } else if (type === 'work_area_locations') {
      let formdata = {
        ids: [...record.ids],
        area_name: record.area_name,
        station: this.state.station,
        location_group: record.location_group,
        module: 'buildup'
      }
      Http.post('/work_arealocation_del', formdata, { headers })
        .then((data) => {
          if(data && data.status === 200){
            this.setState({
              locations: '',
              id_wal: null,
              isWALEdit: false,
              locWorkArea: '',
            },()=>{
              this.clearForm('work_area_locations')
              this.fetchWorkAreaLocations()
              notification.destroy()
              notification.success({
                message: 'Success',
                description: data.data.message,
              })
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    }
  }

  clearForm = (type) =>{
    if(!type || type === 'work_areas'){
      this.setState({
        area_name: '',
        id_wa: null,
        isWAEdit: false,

        p_code: '',
        transfer_type: 'Local',
        dom_intl: 'DOM',
        id_wap: null,
        isWAPEdit: false,
        //prodWorkArea: 'ATL /',

        locations: '',
        id_wal: null,
        isWALEdit: false,
        //locationWorkArea: 'ATL /',
      })
      if(this.state.selworkArea && this.state.selworkArea.area_name)
        this.setState({
          prodWorkArea: this.state.station+' / '+this.state.selworkArea.area_name,
          locWorkArea: this.state.station+' / '+this.state.selworkArea.area_name
        })
      else {
        this.setState({
          prodWorkArea: '',
          locWorkArea: ''
        })
      }
    }
    if(!type ||  type === 'work_area_products'){
      this.setState({
        p_code: '',
        transfer_type: 'Local',
        dom_intl: 'DOM',
        id_wap: null,
        isWAPEdit: false,
        //prodWorkArea: 'ATL /',
      })
      if(this.state.selworkArea && this.state.selworkArea.area_name)
        this.setState({ prodWorkArea: this.state.station+' / '+this.state.selworkArea.area_name })
    }
    if(!type || type === 'work_area_locations'){
      this.setState({
        locations: '',
        id_wal: null,
        isWALEdit: false,
        //locationWorkArea: 'ATL /',
      })
      if(this.state.selworkArea && this.state.selworkArea.area_name)
        this.setState({ locWorkArea: this.state.station+' / '+this.state.selworkArea.area_name })
    }

  }

  editTableForm = (record, type) => {
    if( type === 'work_areas' ){
      this.setState({
        waEditRecord: record,
        editArea_name: record.area_name,
      })
    }
    if(type === 'work_area_products'){
      this.setState({
        wapEditRecord :record,
        editProdWorkArea: record.station+' / '+record.work_area.area_name,
        editP_code: record.details.p_code,
        editTransfer_type: record.details.transfer_type,
        editDom_intl: record.details.dom_intl,
        editprodArea_id: record.work_area.id
      })
    }
    if(type === 'work_area_locations'){
      this.setState({
        walEditRecord :record,
        editLocations: record.location,
        editLocWorkArea: record.station+' / '+record.area_name,
        editlocArea_id: record.id,
        editlocArea_name: record.area_name,
        editlocArea_location_group: record.location_group,
      })
    }
  }

  setSearchValue (e){
    this.setState({ search: e.target.value },()=>{
      if( !e.target.value || e.target.value === null || e.target.value ==='' ){
        this.fetchWorkAreaLocations()
      }
    })
  }

  locationColumnSearch = () => ({
    filterDropdown: () => (
      <div />
    ),
    filterIcon: () =>
      <Form.Item label='' labelCol={{
        lg: { span: 24 },
        xl: { span: 0 },
      }} wrapperCol={{
        lg: { span: 24 },
        xl: { span: 24 },
      }}
      className='w-100 mb-0'
      >
        <Search
          placeholder='Search'
          allowClear
          // enterButton='Search'
          size='small'
          onChange={(e) => this.setSearchValue(e)}
          onSearch={(e)=> !e || e === null || e ==='' ? null : this.fetchWorkAreaLocations()}
          className='search-field w-100 br-input colheader-search'
        />
      </Form.Item>
  })

  clearTableForm = (type) => {
    if( !type || type === 'work_areas'){
      this.setState({
        waEditRecord: null,
        editArea_name: null,
      })
    }
    if(!type || type === 'work_area_products'){
      this.setState({
        wapEditRecord :null,
        editProdWorkArea: null,
        editP_code: null,
        editTransfer_type: '',
        editDom_intl: '',
        editprodArea_id: null
      })
    }
    if(!type || type === 'work_area_locations'){
      this.setState({
        walEditRecord :null,
        editLocations: null,
        editLocWorkArea: null,
        editlocArea_id: null,
        editlocArea_name: null,
        editlocArea_location_group: null,
      })
    }
  }

  /**************************************************************************/

  fetchExceptionList = async ({ id, area_id }) => {
    Http.get(`/work_area_exceptions?station=${this.state.station}&area_id=${area_id}&product_id=${id}`)
      .then((data) => {
        this.setState({
          exceptionList : data?.data?.data || [],
          exceptionType: this.state.exceptionRow?.details?.transfer_type,
          exceptionDomIntl: this.state.exceptionRow?.details?.dom_intl,
          exceptionWorkArea: area_id,
          exceptionProductID: id,
        }, () => this.setState({ showExceptionsModal: true }))
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
  }

  addException = async() => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_exceptions'
    }
    let formdata = new FormData()
    formdata.append('product_id', this.state.exceptionProductID || '')
    formdata.append('area_id', this.state.exceptionWorkArea || '')
    formdata.append('station', this.state.station)
    formdata.append('module', 'buildup')
    formdata.append('value', this.state.exceptionValue || '')
    formdata.append('exception', this.state.exceptionName || '')
    formdata.append('dom_intl', this.state.exceptionDomIntl || '')
    formdata.append('transfer_type', this.state.exceptionName?.toUpperCase() === 'DESTINATION' ? '' : this.state.exceptionType || '')
    await Http.post('/work_area_exception', formdata, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          this.clearExceptionForm()
          this.clearExceptionTableForm()
          this.fetchWorkAreaProducts()
          this.fetchExceptionList(this.state.exceptionRow)
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          this.setState({ eduplicate: data?.data?.data }, () => setTimeout(() => { this.setState({ eduplicate: null }) }, 4500))
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
  }

  updateException = async() => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_exceptions'
    }
    let formdata = new FormData()
    formdata.append('product_id', this.state.exceptionProductID || '')
    formdata.append('area_id', this.state.editExceptionWorkArea || '')
    formdata.append('station', this.state.station)
    formdata.append('module', 'buildup')
    formdata.append('value', this.state.editExceptionValue || '')
    formdata.append('exception', this.state.editExceptionName || '')
    formdata.append('dom_intl', this.state.editExceptionDomIntl || '')
    formdata.append('transfer_type', this.state.editExceptionName?.toUpperCase() === 'DESTINATION' ? '' : this.state.editExceptionType || '')
    await Http.put(`/work_area_exception/${this.state.editExceptionRecord?.id}`, formdata, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          this.clearExceptionTableForm()
          this.fetchWorkAreaProducts()
          this.fetchExceptionList(this.state.exceptionRow)
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          this.setState({ eduplicate: data?.data?.data }, () => setTimeout(() => { this.setState({ eduplicate: null }) }, 4500))
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
  }

  editExceptionTableForm = (record) => {
    this.setState({
      editExceptionRecord: record,
      editExceptionName: record?.details?.exception,
      editExceptionType: record?.details?.exception?.toUpperCase() === 'DESTINATION' ? 'Local' : record?.details?.transfer_type,
      editExceptionValue: record?.details?.value,
      editExceptionDomIntl: record?.details?.dom_intl,
      editExceptionWorkArea: record?.work_area?.id,
    })
  }

  clearExceptionForm = () => {
    this.setState({
      exceptionName: null,
      exceptionValue: null,
      exceptionType: 'Local',
      exceptionWorkArea: null,
      exceptionProductID: null,
      exceptionDomIntl: 'DOM',
    })
  }

  clearExceptionTableForm = () => {
    this.setState({
      editExceptionRecord: null,
      editExceptionName: null,
      editExceptionValue: null,
      editExceptionType: null,
      editExceptionWorkArea: null,
      editExceptionDomIntl: null,
    })
  }

  deleteException = async (id) => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping + '_exceptions'
    }
    let formdata = {
      station: this.state.station,
      is_delete: true,
      module: 'buildup'
    }
    await Http.put(`/work_area_exception/${id}`, formdata, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          //this.clearForm()
          this.fetchWorkAreaProducts()
          this.fetchExceptionList(this.state.exceptionRow)
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      })
  }

  // Exceptions Modal
  exceptionsAvailable = () => {
    this.setState({ showExceptionsModal: true })
  }
  exceptionsHide = () => {
    this.clearExceptionForm()
    this.clearExceptionTableForm()
    this.setState({ showExceptionsModal: false })
  }

  saveAmberValue = async () => {
    let headers = {
      user_id: cookies.get('id'),
      page_title: titles.buildup_area_mapping
    }
    let formdata = {
      station: this.state.station,
      onlybooked: this.state.only_booked, //boolean
      red_locations: this.state.red_locations, //comma seperated string
      amber_locations: this.state.amber_locations, //comma seperated string
      module: 'buildup'
    }
    if(this.state.system_details?.length > 0) {
      Http.put(`/station_detail/${this.state.system_details[0]?.id}`, formdata, { headers })
        .then((data) => {
          if(data && data.status === 200){
            this.fetchAmberValue()
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data.data.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    } else {
      Http.post('/station_detail', formdata, { headers })
        .then((data) => {
          if(data && data.status === 200){
            this.fetchAmberValue()
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data.data.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    }
  }

  render() {

    const workAreaColumns = [
      {
        title: 'Work Area',
        key: 'workarea',
        render: (string, record) =>(
          this.state.waEditRecord && this.state.waEditRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editArea_name}
              onChange={(e) => this.setState({ editArea_name: e.target.value })}
            />
            :
            <span className={record.id === this.state.duplicate?.id ?'red-border': ''}>{
              record.area_name? record.area_name : '-' }
            </span>
        )
      },
      {
        title: 'Action',
        // dataIndex: 'action',
        key: 'action',
        align: 'center',
        render: (string, record) =>
          <div>
            { this.state.waEditRecord && this.state.waEditRecord.id === record.id ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.updateWorkAreas('work_areas')} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.clearTableForm('work_areas')} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.editTableForm(record, 'work_areas')} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} okText='Yes' cancelText='No' onConfirm={()=>this.deleteHandler(record, 'work_areas')} >
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>
            }
          </div>
      },
    ]

    const pworkAreaColumns = [
      {
        title: 'Station / Work Area',
        //dataIndex: 'workarea',
        key: 'workarea',
        render: (text, record) => (
          this.state.wapEditRecord && this.state.wapEditRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              disabled
              value={this.state.editProdWorkArea}
            />
            :
            <span className={record.id === this.state.pduplicate?.id ?'red-border': ''}>{
              record && record.work_area && record.station ? record.station+ ' / '+ record.work_area.area_name  : '-'}
            </span>
        )
      },
      {
        title: 'Product Code',
        //dataIndex: 'productcode',
        key: 'productcode',
        render: (text, record) => (
          this.state.wapEditRecord && this.state.wapEditRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editP_code}
              onChange={(e) => this.setState({ editP_code: e.target.value.toUpperCase() })}
            />
            :
            <span className={record.id === this.state.pduplicate?.id ?'red-border': ''}>{
              record && record.details && record.details.p_code ? record.details.p_code  : '-'}
            </span>
        )
      },
      {

        title: 'Local/Transfer',
        key: 'transfer_type',
        render: (text, record) => (
          this.state.wapEditRecord && this.state.wapEditRecord.id === record.id ?
            <Select size='small' value={this.state.editTransfer_type} onChange={(e) => this.setState({ editTransfer_type: e })}>
              <Option value='Local'>Local</Option>
              <Option value='Transfer'>Transfer</Option>
            </Select>
            :
            <span className={record.id === this.state.duplicate?.id ?'red-border': ''}>{record?.details?.transfer_type}</span> )
      },
      {
        title: 'Dom / Intl',
        key: 'dom_intl',
        className:'',
        render: (text, record) => (
          this.state.wapEditRecord && this.state.wapEditRecord.id === record.id ?
            <Select size='small' value={this.state.editDom_intl} onChange={(e) => this.setState({ editDom_intl: e })}>
              <Option value='DOM'>DOM</Option>
              <Option value='INTL'>INTL</Option>
            </Select>
            :
            <span className={record.id === this.state.duplicate?.id ?'red-border': ''}>{record?.details?.dom_intl}</span> )
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        render: (string, record) =>
          <div>
            { this.state.wapEditRecord && this.state.wapEditRecord.id === record.id ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.updateWorkAreaProducts('work_area_products')} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.clearTableForm('work_area_products')} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Exceptions' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <Badge count={record.work_area_exceptions.length} className='notes-badge' size='small'>
                    <Button
                      type='text'
                      icon={<FilterOutlined />}
                      onClick={()=>this.setState({ exceptionRow: record }, () => this.fetchExceptionList(this.state.exceptionRow))}
                    />
                  </Badge>
                </Tooltip>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.editTableForm(record, 'work_area_products')} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} okText='Yes' cancelText='No' onConfirm={()=>this.deleteHandler(record, 'work_area_products')} >
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>
            }
          </div>
      },
    ]
    const lworkAreaColumns = [
      {
        title: 'Work Area',
        key: 'workarea',
        width: '30%',
        render: (text, record) => (
          this.state.walEditRecord && this.state.walEditRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              disabled
              value={this.state.editLocWorkArea}
            />
            :
            <span className={record.id === this.state.lduplicate?.id ?'red-border': ''}>{
              record && record.area_name ? record.area_name  : '-'}
            </span>
        )
      },
      {
        title: 'Location(s)',
        key: 'location',
        width: '60%',
        className:'table-header-search',
        render: (text, record) => (
          this.state.walEditRecord && this.state.walEditRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editLocations}
              onChange={(e) => this.setState({ editLocations: e.target.value.toUpperCase() })}
            />
            :
            <span className={record.id === this.state.lduplicate?.id ?'red-border': ''}>{
              record && record.location ? record.location.split(',').join(', ') : '-'}
            </span>
        ),
        ...this.locationColumnSearch(),
      },
      {
        title: 'Action',
        dataIndex: 'action',
        width: '10%',
        key: 'action',
        align: 'center',
        render: (string, record) =>
          <div>
            { this.state.walEditRecord && this.state.walEditRecord.id === record.id ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.updateWorkAreaLocations('work_area_locations')} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.clearTableForm('work_area_locations')} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={()=>this.editTableForm(record, 'work_area_locations')} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} okText='Yes' cancelText='No' onConfirm={()=>this.deleteHandler(record, 'work_area_locations')} >
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>
            }
          </div>
      },
    ]

    // Exceptions Table
    const excptionColumns = [
      {
        title: 'Exception',
        dataIndex: 'exception',
        key: 'exception',
        render: (_, record) => (
          this.state.editExceptionRecord && this.state.editExceptionRecord.id === record.id ?
            <Select
              placeholder='Select exception'
              value={this.state.editExceptionName}
              onChange={(e) => this.setState({ editExceptionName: e })}
            >
              <Option value='AWB Prefix'>AWB Prefix</Option>
              <Option value='Destination'>Destination</Option>
              <Option value='Flights'>Flights</Option>
            </Select>
            :
            <span className={record.id === this.state.eduplicate?.id ? 'red-border' : ''}>{!record?.details?.exception ? 'NA' : record?.details?.exception}</span>
        )
      },
      {
        title: 'Value',
        dataIndex: 'value',
        key: 'value',
        render: (_, record) => (
          this.state.editExceptionRecord && this.state.editExceptionRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editExceptionValue}
              onChange={(e) => this.setState({ editExceptionValue: e.target.value.toUpperCase() })}
            />
            :
            <span className={record.id === this.state.eduplicate?.id ? 'red-border' : ''}>{!record?.details?.value ? 'NA' : record?.details?.value}</span>
        )
      },
      {
        title: 'Transfer/Local',
        dataIndex: 'transfer_type',
        key: 'transfer_type',
        render: (_, record) => (
          this.state.editExceptionRecord && this.state.editExceptionRecord.id === record.id ?
            <Select
              placeholder='Select'
              value={this.state.editExceptionType}
              disabled={true}
              // onChange={(e) => this.setState({ editExceptionType: e })}
              // disabled={this.state.editExceptionName?.toUpperCase() === 'DESTINATION'}
            >
              <Option value='Local'>Local</Option>
              <Option value='Transfer'>Transfer</Option>
            </Select>
            :
            <span className={record.id === this.state.eduplicate?.id ? 'red-border' : ''}>{!record?.details?.transfer_type ? 'NA' : record?.details?.transfer_type}</span>
        )
      },
      {
        title: 'Dom/Intl',
        dataIndex: 'dom_intl',
        key: 'dom_intl',
        render: (_, record) => (
          this.state.editExceptionRecord && this.state.editExceptionRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editExceptionDomIntl}
              disabled={true}
              // onChange={(e) => this.setState({ editExceptionDomIntl: e.target.value })}
            />
            :
            <span className={record.id === this.state.eduplicate?.id ? 'red-border' : ''}>{!record?.details?.dom_intl ? 'NA' : record?.details?.dom_intl}</span>
        )
      },
      {
        title: 'Map To',
        dataIndex: 'map_to',
        key: 'map_to',
        render: (_, record) => (
          this.state.editExceptionRecord && this.state.editExceptionRecord.id === record.id ?
            <Select
              placeholder='Select work area'
              value={this.state.editExceptionWorkArea}
              disabled={true}
              // onChange={(e) => this.setState({ editExceptionWorkArea: e })}
            >
              {this.state.workAreasList?.map((wa) => (
                <Option key={wa.area_name} value={wa.ids[0]} title={wa.area_name}>{wa.area_name}</Option>
              ))}
            </Select>
            :
            <span className={record.id === this.state.eduplicate?.id ? 'red-border' : ''}>{!record?.work_area?.area_name ? 'NA' : record?.work_area?.area_name}</span>
        )
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        render: (_, record) =>
          <div>
            <div className='action-column'>
              {this.state.editExceptionRecord && this.state.editExceptionRecord.id === record.id ?
                <div className='action-column'>
                  <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={this.updateException} ><img src={Update} alt='Save' /></Tooltip>
                  <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={this.clearExceptionTableForm} ><span className='form-clear'>x</span></Tooltip>
                </div> :
                <div className='action-column'>
                  <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editExceptionTableForm(record)}><img src={editIcon} alt='edit' /></Tooltip>
                  <Popconfirm placement='top' title={constants.DeleteText} okText='Yes' cancelText='No' onConfirm={() => this.deleteException(record.id)}>
                    <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                  </Popconfirm>
                </div>
              }
            </div>
          </div>
      },
    ]

    // rowSelection object indicates the need for row selection
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.clearForm('work_areas')
        this.setState({
          selworkArea: cloneDeep(selectedRows[0]),
          prodWorkArea: this.state.station+' / '+cloneDeep(selectedRows[0]).area_name,
          locWorkArea: this.state.station+' / '+cloneDeep(selectedRows[0]).area_name
        },()=>{
          this.fetchWorkAreaProducts()
          this.fetchWorkAreaLocations()
        }
        )
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column configuration not to be checked
        name: record.name,
      })
    }

    return (
      <div>
        <Row gutter={[{
          xs: 0,
          sm: 0,
          md: 24,
          lg: 24
        }, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24
        },]} >
          <Col xs={24} className=''>
            <Card className='custom-card h-100'>
              <Row gutter={[{
                xs: 0,
                sm: 0,
                md: 24,
                lg: 24
              }, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24
              },]} className='with-table'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Title level={5} className='mb-0'>General station specific settings | Build Up | {this.state.station || ''}</Title>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Form
                    layout='vertical'
                    className='position-relative'
                  >
                    <Row
                      gutter={[{
                        xs: 0,
                        sm: 0,
                        md: 24,
                        lg: 24
                      }, {
                        xs: 0,
                        sm: 0,
                        md: 0,
                        lg: 0
                      },]} >
                      <Col xs={24} sm={24} md={24} lg={12} xl={9} className=''>
                        <Form.Item label=''>
                          <Radio.Group className='f-spacebtw mt-4' onChange={(e) => this.setState({ only_booked: e.target.value })} value={this.state.only_booked}>
                            <Radio value={false}>Display booked and assigned cargo for build up lists</Radio>
                            <Radio value={true}>Display only booked cargo on build up lists</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={6} xl={7} flex='auto' className=''>
                        <Form.Item label='Enter locations to be displayed in red Comma Separated'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.red_locations}
                            onChange={(e) => this.setState({ red_locations: e.target.value.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={6} xl={7} flex='auto' className=''>
                        <Form.Item label='Enter locations to be displayed in amber Comma Separated'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.amber_locations}
                            onChange={(e) => this.setState({ amber_locations: e.target.value.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col className='ml-auto'>
                        <label className='custom-label transparent d-block'>-</label>
                        <Button className='custom-icon-button ml-auto mt-5px' icon={<SaveOutlined />} onClick={this.saveAmberValue}></Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={{
            span: 24,
            order: 1
          }} sm={{
            span: 24,
            order: 1
          }} md={{
            span: 10,
            order: 1
          }}
          lg={{
            span: 10,
            order: 1
          }} xl={{
            span: 10,
            order: 1
          }} xxl={{
            span: 5,
            order: 1
          }} className=''>
            <Card className='custom-card h-100'>
              <Row gutter={[{
                xs: 0,
                sm: 0,
                md: 24,
                lg: 24
              }, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24
              },]} className='with-table'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Title level={5} className='mb-0'>Work Areas</Title>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Form
                    layout='vertical'
                    className='position-relative'
                  >
                    <Row
                      gutter={[{
                        xs: 0,
                        sm: 0,
                        md: 24,
                        lg: 24
                      }, {
                        xs: 0,
                        sm: 0,
                        md: 0,
                        lg: 0
                      },]} >
                      <Col xs={24} sm={24} flex='auto' className=''>
                        <Form.Item label='Work Area Name'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.area_name}
                            onChange={(e) => this.setState({ area_name: e.target.value })}
                          />
                        </Form.Item>
                      </Col>
                      <Col flex='50px' className='text-center ml-auto'>
                        <label className='custom-label transparent'>-</label>
                        <Button type='ghost' className='ml-auto image-btn' onClick={() => this.state.isWAEdit ? this.updateWorkAreas() : this.addWorkAreas()}>
                          <Tooltip title={this.state.isWAEdit ?'Update' :'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
                  <div className='table-outer'>
                    <Table
                      rowKey='id'
                      className='custom-table bu-table w-100'
                      columns={workAreaColumns}
                      dataSource={this.state.workAreasList}
                      pagination={false}
                      rowSelection={{
                        type: 'radio',
                        ...rowSelection,
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={{
            span: 11,
            order: 1
          }} sm={{
            span: 24,
            order: 2
          }} md={{
            span: 24,
            order: 3
          }} lg={{
            span: 24,
            order: 3
          }}
          xl={{
            span: 24,
            order: 3
          }} xxl={{
            span: 10,
            order: 2
          }} className=''>
            <Card className='custom-card h-100'>
              <Row gutter={[{
                xs: 0,
                sm: 0,
                md: 24,
                lg: 24
              }, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24
              },]} className='with-table'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='f-spacebtw'>
                  <Title level={5} className='mb-0'>Products to work area mapping</Title>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Form
                    layout='vertical'
                    className='position-relative'
                  >
                    <Row
                      gutter={[{
                        xs: 0,
                        sm: 0,
                        md: 24,
                        lg: 24
                      }, {
                        xs: 0,
                        sm: 0,
                        md: 0,
                        lg: 0
                      },]} >
                      <Col xs={24} sm={24} md={6} lg={5} xl={7} xxl={6} className=''>
                        <Form.Item label='Station / Work Area'>
                          <Input
                            size='small'
                            placeholder=''
                            disabled
                            value={this.state.prodWorkArea}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={6} lg={5} xl={7} xxl={6} className=''>
                        <Form.Item label='Enter Product Code'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.p_code}
                            onChange={(e) => this.setState({ p_code: e.target.value.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} flex='auto' className='local'>
                        <Form.Item label='Local/Transfer'>
                          <Select value={this.state.transfer_type} onChange={(e) => this.setState({ transfer_type: e })}>
                            <Option value='Local'>Local</Option>
                            <Option value='Transfer'>Transfer</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} flex='auto' className='local'>
                        <Form.Item label='Dom/Intl'>
                          <Select value={this.state.dom_intl} onChange={(e) => this.setState({ dom_intl: e })}>
                            <Option value='DOM'>DOM</Option>
                            <Option value='INTL'>INTL</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col flex='30px' className='text-center ml-auto'>
                        <label className='custom-label transparent'>-</label>
                        <Button type='ghost' className='ml-auto image-btn' onClick={() => this.state.isWAPEdit ? this.updateWorkAreaProducts() : this.addWorkAreaProducts()} >
                          <Tooltip title={this.state.isWAPEdit ?'Update' :'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
                  <div className='table-outer'>
                    <Table
                      className='custom-table bu-table w-100'
                      columns={pworkAreaColumns}
                      dataSource={this.state.workAreasProductsList}
                      pagination={false}
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col xs={{
            span: 11,
            order: 1
          }} sm={{
            span: 24,
            order: 2
          }} md={{
            span: 14,
            order: 2
          }}
          lg={{
            span: 14,
            order: 2
          }} xl={{
            span: 14,
            order: 2
          }} xxl={{
            span: 9,
            order: 3
          }} className=''>
            <Card className='custom-card h-100'>
              <Row gutter={[{
                xs: 0,
                sm: 0,
                md: 24,
                lg: 24
              }, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24
              },]} className='with-table'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Title level={5} className='mb-0'>Locations to work area mapping</Title>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Form
                    layout='vertical'
                    className='position-relative'
                  >
                    <Row
                      gutter={[{
                        xs: 0,
                        sm: 0,
                        md: 24,
                        lg: 24
                      }, {
                        xs: 0,
                        sm: 0,
                        md: 0,
                        lg: 0
                      },]} >
                      <Col xs={24} sm={24} md={7} lg={9} xl={10} xxl={8} className=''>
                        <Form.Item label='Station / Work Area'>
                          <Input
                            size='small'
                            placeholder=''
                            disabled
                            value={this.state.prodWorkArea}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={14} lg={14} xl={10} xxl={14} flex='auto' className=''>
                        <Form.Item label='Enter up to 10 locations comma separated'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.locations}
                            onChange={(e) => this.setState({ locations: e.target.value.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col flex='30px' className='text-center ml-auto'>
                        <label className='custom-label transparent'>-</label>
                        <Button type='ghost' className='ml-auto image-btn' onClick={() => this.state.isWALEdit ? this.updateWorkAreaLocations() : this.addWorkAreaLocations()} >
                          <Tooltip title={this.state.isWALEdit ?'Update' :'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                        </Button>
                      </Col>
                      {  this.state.isWALEdit ? (
                        <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                          <Button type='ghost' className='ml-auto image-btn clear-btn fleet-btn-placement' onClick={() => this.clearForm('work_area_locations')}>
                            <span className='close-icon'>x</span>
                          </Button>
                        </Tooltip>
                      )
                        : null
                      }
                    </Row>
                  </Form>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
                  <div className='table-outer'>
                    <Table
                      className='custom-table bu-table w-100'
                      columns={lworkAreaColumns}
                      dataSource={this.state.workAreasLocationsList}
                      pagination={false}
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Modal
          title='Exceptions for product to work area mapping'
          visible={this.state.showExceptionsModal}
          onOk={this.exceptionsHide}
          onCancel={this.exceptionsHide}
          className='custom-modal pb-0'
          width={'50%'}
          centered
          footer={false}
        >
          <Row gutter={[{
            xs: 0,
            sm: 0,
            md: 24,
            lg: 24
          }, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24
          },]} className='with-table'>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
              <Form
                layout='vertical'
                className='position-relative'
              >
                <Row
                  gutter={[{
                    xs: 0,
                    sm: 0,
                    md: 0,
                    lg: 24
                  }, {
                    xs: 0,
                    sm: 0,
                    md: 0,
                    lg: 0
                  },]} >
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                    <Title level={5} className='mb-2'>{`${this.state.station} / ${this.state.exceptionRow?.work_area?.area_name} - ${this.state.exceptionRow?.details?.p_code}`}</Title>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={6} className='local'>
                    <Form.Item label='Select Exception'>
                      <Select
                        placeholder='Select exception'
                        value={this.state.exceptionName}
                        onChange={(e) => this.setState({ exceptionName: e })}
                      >
                        <Option value='AWB Prefix'>AWB Prefix</Option>
                        <Option value='Flights'>Flights</Option>
                        <Option value='Destination'>Destination</Option>
                        <Option value=''>Connex Less Than (Mins)</Option>
                        <Option value=''>Connex More Than (Mins)</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={4} className=''>
                    <Form.Item label='Value'>
                      <Input
                        size='small'
                        placeholder=''
                        value={this.state.exceptionValue}
                        onChange={(e) => this.setState({ exceptionValue: e.target.value.toUpperCase() })}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={4} className='local'>
                    <Form.Item label='Transfer/Local'>
                      <Select
                        placeholder='Select'
                        value={this.state.exceptionRow?.details?.transfer_type}
                        disabled={true}
                        // onChange={(e) => this.setState({ exceptionType: e })}
                        // disabled={this.state.exceptionName?.toUpperCase() === 'DESTINATION'}
                      >
                        <Option value='Local'>Local</Option>
                        <Option value='Transfer'>Transfer</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={4} className=''>
                    <Form.Item label='Dom/Intl'>
                      <Select
                        value={this.state.exceptionRow?.details?.dom_intl}
                        disabled={true}
                        // onChange={(e) => this.setState({ exceptionDomIntl: e })}
                      >
                        <Option value='DOM'>DOM</Option>
                        <Option value='INTL'>INTL</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={4} className='local'>
                    <Form.Item label='Map To'>
                      <Select
                        placeholder='Select work area'
                        value={this.state.exceptionRow?.work_area?.id}
                        disabled={true}
                        // onChange={(e) => this.setState({ exceptionWorkArea: e })}
                      >
                        {this.state.workAreasList?.map((wa) => (
                          <Option key={wa.area_name} value={wa.ids[0]} title={wa.area_name}>{wa.area_name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col flex='40px' className='text-center ml-auto pl-0'>
                    <label className='custom-label transparent'>-</label>
                    <Button type='ghost' className='ml-auto image-btn' onClick={this.addException}>
                      <Tooltip title={'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
              <div className='table-outer'>
                <Table
                  className='custom-table w-100'
                  dataSource={this.state.exceptionList}
                  columns={excptionColumns}
                  pagination={false}
                />
              </div>
            </Col>
          </Row>
        </Modal>
      </div>
    )
  }
}

export default BuildUpAreaMapping
